// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/captain/captain.actions.go

import { type Scope } from "~/hooks/useScope";
import { LIST_ORGANIZATION_MEMBERSHIPS } from "./action";

export function canListOrganizationMemberships(scope: Scope): boolean {
  return scope.iamActions.includes(LIST_ORGANIZATION_MEMBERSHIPS);
}
